<template>
  <div class="video-detail-container basic_video_detail_index"   
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
    ref="basic_video_detail_index"
    :style="{'--theme_color': theme_color}"
    > 
    <div class="tooptipPart">
      <my_edit_btn :module="module" :title="$t('widgets_basic_article_classification_index_336')"></my_edit_btn>
      <my_edit_btn :module="module" tabName="animation" :title="$t('widgets_basic_article_classification_edit_330')" v-if="isPc"></my_edit_btn>
      <!--<my_edit_btn cover-click></my_edit_btn>-->
      <div class="my_edit_btn  lineControl styleContent" @click="edit" v-if="isPc">
        <span class="el-icon-edit-outline" :title="$t('widgets_basic_article_info_index_354')"></span>
      </div>
      <!--<my_close_btn :module="module" :column="column" :moduleIndex="module_index"></my_close_btn>-->
    </div>
   
    <!-- 视频详情 pc端展示和手机端展示不一样 先写pc端 -->
    <div class="pc-detail-content">
      <!-- 视频详情 -->
      <!-- v-if="$store.state.app.view_pattern === 'pc'" -->
      <div class="video-top" >
        <div class="video-center">
          <!-- 添加了 边 -->
          <div class="video-border">
            <video :src="video_detail.content" controls="controls" class="video"></video>
          </div>
          
        </div>
        <div class="video-detail">
          <p class="video-title">{{video_detail.title}}</p>
          <p class="video-desc">{{video_detail.summary}}</p>
          <!-- 分享  下载  用手机看 -->
          <div class="detail_func_wrap" >
            <div class="share-left">
              <div class="detail_share" >
                <template v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile' && $store.state.app.language === 'zh-cn'">
                  <my_share_render class="share" :share-type="pc_widgets_infor.shareType" title=""
                  v-if="pc_widgets_infor.share === 'open'" :large-show="false"></my_share_render>
                </template>
                <template v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile' && $store.state.app.language !== 'zh-cn'">
                  <my_share_render class="share" :share-type="pc_widgets_infor.enShareType" title=""
                  v-if="pc_widgets_infor.share === 'open'" :large-show="false"></my_share_render>
                </template>
              </div>
               <a  v-if="listArr.download == 'block'" style="color:#657180" :href="`javascript:download('${video_detail.content}','${video_detail.title}');`" target="_self" :title="$t('router_index_69')">
                <!-- <i class="icon-download el-icon-download"></i> -->
                <i class="fa fa-arrow-circle-o-down icon-download"></i>
              </a>
              <el-popover
                placement="bottom-start"
                trigger="hover"
                v-if="$store.state.app.view_pattern === 'pc'"
                >
                <div id="qrcode"></div>
                <div class="see-txt" slot="reference">
                  <i class="fa fa-mobile-phone icon-phone"></i>
                  {{getLang($t('widgets_basic_video_detail_index_2891'))}}
                </div>
              </el-popover>
            </div>

            <!-- 播放量 -->
            <div class="detail-play" v-if="listArr.play_count == 'block'">{{getLang($t('widgets_basic_video_detail_index_2892'))}}:{{video_detail.click}}</div>
          </div>
          <div class="detail_share_tile" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle === 'tile'">
            <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.shareType"
              v-if="$store.state.app.language === 'zh-cn'"></my_share_render>
            <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.enShareType"
              v-if="$store.state.app.language !== 'zh-cn'"></my_share_render>
          </div>
          
          <div class="detail_pagination_wrap" v-if="pc_widgets_infor.firstAndNextShow === 'true'">
              <div v-if="preNextData.pre" class="nav-btn-wrapper nav-btn-wrapper-left" @click="prev_page">
                <div class="btn prev" :style="preNextData.pre ? 'color: #999' : ''">{{ getLang($t('widgets_basic_article_info_index_355'))}}</div>
                <span class="nav-btn-title" :title="preNextData.pre.title">{{ preNextData.pre.title }}</span>
              </div>
              <div v-if="preNextData.next" class="nav-btn-wrapper nav-btn-wrapper-right" @click="next_page">
                <div class="btn next" :style="preNextData.next ? 'color: #999' : ''">{{ getLang($t('widgets_basic_article_info_index_356'))}}</div>
                <span class="nav-btn-title" :title="preNextData.next.title">{{ preNextData.next.title }}</span>
              </div>
          </div>

        </div>
      </div>
      <div class="video-top-mb" >
        <p class="video-title">{{video_detail.title}}</p>
        <p class="video-desc">{{video_detail.summary}}</p>
        <!-- 分享  下载  用手机看 -->
        <div class="detail_func_wrap" >
          <div class="share-left">
            <div class="detail_share"  >
            <template v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile' && $store.state.app.language === 'zh-cn'">
              <my_share_render class="share" :share-type="pc_widgets_infor.shareType" title=""
              v-if="pc_widgets_infor.share === 'open'" :large-show="false"></my_share_render>
            </template>
            <template v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle !== 'tile' && $store.state.app.language !== 'zh-cn'">
              <my_share_render class="share" :share-type="pc_widgets_infor.enShareType" title=""
              v-if="pc_widgets_infor.share === 'open'" :large-show="false"></my_share_render>
            </template>

          </div>
           <a class="download-wrap"  v-if="listArr.download == 'block'" style="color:#657180" :href="`javascript:download('${video_detail.content}','${video_detail.title}');`" target="_self" :title="$t('router_index_69')">
              <!-- <i class="icon-download el-icon-download"></i> -->
               <i class="fa fa-arrow-circle-o-down icon-download"></i>
            </a>
          </div>

          <!-- 播放量 -->
          <div class="detail-play" v-if="listArr.play_count == 'block'">{{getLang($t('widgets_basic_video_detail_index_2892'))}}:{{video_detail.click}}</div>
        </div>
        <div class="detail_share_tile" v-if="pc_widgets_infor.share === 'open' && pc_widgets_infor.shareDisplayStyle === 'tile'">
          <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.shareType"
            v-if="$store.state.app.language === 'zh-cn'"></my_share_render>
          <my_share_render display-style="tile" title="" :share-type="pc_widgets_infor.enShareType"
            v-if="$store.state.app.language !== 'zh-cn'"></my_share_render>
        </div>
        <div class="video-center">
          <video :src="video_detail.content" controls="controls" class="video"></video>
        </div>
      </div>
      <!-- 相关推荐 -->
      <div :class="[$store.state.app.view_pattern === 'pc' ?'video-recommend': 'video-recommend-mb' ]" v-if="listArr.recommend == 'block'">
        <!-- 相关推荐 -->
        <div class="recommend-title">{{getLang($t('widgets_basic_video_detail_index_2893'))}}</div>
        <!--  @getProduct="getProduct"
            @delete_video="delete_video" -->
        <div class="empty" v-if="video_list.length ==0">
          <div class="jz_empty_tips u-box">
            <i class="jz_empty_tips__img"></i>
            <div class="jz_empty_tips__text">
              {{getLang($t('widgets_basic_article_list_index_416'))}}
            </div>
          </div>
        </div>
        <div class="recommend-content" v-else>
          <one_img
            v-for="(item, i) in video_list"
            :key="i"
            :item="item"
            :module="module"
            :hideBtn="false"
            @getProduct="videoList"
            @delete_video="delete_video"
          ></one_img>
        </div>
      </div>
    </div>
    <basic_addArticle
      :article-type="type"
      :edit-id="id"
      v-if="showEditArticle"
      @closed="closeEditArticle"
      @submit_sure="videoDetail"
    ></basic_addArticle>
  </div>
</template>


<script type="text/javascript">
import i18n from '../../language/index'

import {getArticleEdit, getArticleListBy1, deleteArtical, get_home} from '@/api/app.js'
import  QRCode from 'qrcodejs2'
// let QRCode = require('@/base/qrcode.js').QRCode
import one_img from "./components/one_img"
import my_share_render from './../../components/my_share/render'
import { getPreNext } from './../../api/app.js'

export default {
  name: 'basic_video_detail_index',
   props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  data(){
    return {
      video_detail: {},
      video_list:[],
      isHover: false,
      isEmpty: false,
      editId: -1,
      type: 1,
      showEditArticle: false,
      id: '',
      qrcode: null,
      preNextData: {pre: '', next: ''}
    }
  },
  computed: {
    theme_color() {
      return this.$store.state.myRender.common.theme_color
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor
    },
    mb_widgets_infor() {
      return this.module.data.mb_widgets_infor
    },
    listArr() {
      return this.module.data.listArr
    },
    isPc() {
      return this.$store.state.app.view_pattern === 'pc'
    },
    is_road_type() {
      return this.$store.getters['app/is_road_type']
    },
    recommend_video_num() { // 相关视频推荐个数
      return this.$store.state.app.view_pattern === 'pc' ? Number(this.pc_widgets_infor.recommend_video_num) : Number(this.mb_widgets_infor.recommend_video_num)
    }
  },
  created() {
    this.fixField()
  },
  async mounted(){
    this.videoDetail()
    if(this.listArr.recommend == 'block') {
      // setTimeout(() => {
        await this.get_home()
        this.videoList()
      // }, 1000)
    }
    this.editId = Number(this.$route.query.id)
    this.id = Number(this.$route.query.id)
    // 4.3.16 视频详情 推荐个数 pc和手机端保持一致
    this.initRecomend()
    this.getPreNext()
  },
  methods: {
    prev_page() {
      if (this.preNextData.pre) {
        let query = {id: this.preNextData.pre.id}
        if(this.is_road_type)query.tag_id = this.preNextData.pre.tag_ids
        let name = this.$route.name
        if (this.$store.state.app.is_change) {
          this.$confirm(i18n.t('widgets_basic_article_info_index_360'), i18n.t('view_public_topbar_23'), {
            confirmButtonText: i18n.t('widgets_basic_article_info_index_361'),
            cancelButtonText: i18n.t('view_public_topbar_11'),
            center: true,
            appendToBody: true
          }).then(() => {
            this.$store.state.main_dialog.main_dialog_isShow = false
            this.$router.push({
              name,
              query
              /* name: 'product',
              query: {id: this.prevPageID} */
            })
          }).catch(action => {
            console.log('取消弹窗')
          })
        } else {
          this.$store.state.main_dialog.main_dialog_isShow = false
          this.$router.push({
            name,
            query
            /* name: 'article',
            query: {id: this.infoData.prevId} */
          })
        }

      }
    },
    next_page() {
      if (this.preNextData.next) {
        let query = {id: this.preNextData.next.id}
        if(this.is_road_type)query.tag_id = this.preNextData.next.tag_ids
        let name = this.$route.name
        if (this.$store.state.app.is_change) {
          this.$confirm(i18n.t('widgets_basic_article_info_index_360'), i18n.t('view_public_topbar_23'), {
            confirmButtonText: i18n.t('widgets_basic_article_info_index_361'),
            cancelButtonText: i18n.t('view_public_topbar_11'),
            center: true,
            appendToBody: true
          }).then(() => {
            this.$store.state.main_dialog.main_dialog_isShow = false
            this.$router.push({
              name,
              query
              /* name: 'product',
              query: {id: this.nextPageID} */
            })
          }).catch(action => {
            console.log('取消弹窗')
          })
        } else {
          this.$store.state.main_dialog.main_dialog_isShow = false
          this.$router.push({
            name,
            query
            /* name: 'article',
            query: {id: this.infoData.nextId} */
          })
        }
      }
    },
    getPreNext(){
      if(!this.id) return
      getPreNext({
          id: this.id,
          module_name: 'video'
        }).then(res => {
          if (res.code !== 200) return this.$message.error(res.message)
          this.preNextData.pre = res.data.pre ? res.data.pre : ''
          this.preNextData.next = res.data.next ? res.data.next : ''
        })
    },
    fixField() {
      if (typeof this.pc_widgets_infor.enShareType == 'undefined') {
        this.$set(this.pc_widgets_infor, 'enShareType', ['twitter','wechat','facebook','linkedin'])
      }
      if (typeof this.pc_widgets_infor.shareDisplayStyle == 'undefined') {
        this.$set(this.pc_widgets_infor, 'shareDisplayStyle', 'default')
      }
    },
    initRecomend() {
      if(!this.pc_widgets_infor.recommend_video_num)  {
        this.$set(this.pc_widgets_infor, 'recommend_video_num', 10)
      }
      if(!this.mb_widgets_infor.recommend_video_num)  {
        this.$set(this.mb_widgets_infor, 'recommend_video_num', 4)
      }
      if(typeof this.pc_widgets_infor.firstAndNextShow == "undefined"){
        this.$set(this.pc_widgets_infor, 'firstAndNextShow', 'false')
      }
      if(typeof this.pc_widgets_infor.recommendationOption == "undefined"){
        this.$set(this.pc_widgets_infor, 'recommendationOption', 'system')
      }
      if(typeof this.listArr.articleList == "undefined"){
        this.$set(this.listArr, 'articleList', [])
      }
      
    },
    async get_home() {
      let res = await  get_home()
      if (res.code == 200 && res.data && res.data.role) {
        this.$store.commit('app/set_road_type', res.data.road_type);
      }
   },
    async videoDetail() { //获取视频详情
    const id = this.$route.query.id || this.$route.query.typeId
      if(!id) {
        return
      }
      let res = await getArticleEdit({
        id: id
      })
      if(res.code === 200){
        this.type = res.data.info.type
        this.video_detail = {
          ...res.data.info
        }
        if(this.$store.state.app.view_pattern === 'pc'){
          this.$nextTick(()=> {
            this.getCodeImg()
          })
        }
        // 生产二维码
      } else {
        this.$message.error(res.message)
      }
    },
    async videoList() {
      let params = {
        type: 11, // 类型 type:11
        // rows: this.$store.state.app.view_pattern === 'pc' ? 11: 5, // 每页显示的个数 多请求一个是为了过滤这样详情中存在了 list 中
        // 4.3.16 这边 视频详情 相关视频手机端的推荐个数 和pc端的推荐个数不一样
        rows: this.recommend_video_num+1,
        page: 1,
        // category_id: this.isSystem ? this.$route.query.typeId || "" : "", // 分类id
        is_up: "true",
      };
      // 外贸站的 相关视频是标签视频 
      if(this.pc_widgets_infor.recommendationOption === 'system'){
        params.id = this.$route.query.id
        let res= await getArticleListBy1({
          ...params,          
        }, this.pc_widgets_infor.recommendationOption)
        // console.log(res)
        if(res.code === 200){ // 过滤 详情的那个 最后要是个
          // let num = this.$store.state.app.view_pattern === 'pc' ? 11: 5 // 显示10条 或者是4条 
          if(res.data && res.data.rows){
            console.log('res.data.rows123', res.data.rows);
            this.video_list = [...res.data.rows].slice(0, this.recommend_video_num)
          }else{
            this.video_list = []
          }
        } else {
          this.$message.error(res.message)
        }
      }else{
        if(this.listArr.articleList && this.listArr.articleList.length === 0){
          this.video_list = []
          return
        }
        if(this.listArr.articleList && this.listArr.articleList.length > 0){
          params = {
            type: 11,
            page: 1,
            ids: this.listArr.articleList.join(','),
            is_up: "true",
          };
          let res= await getArticleListBy1({
            ...params
          })
          if(res.code === 200){
            // this.video_list = res.data.rows.filter(item=> item.id !=this.$route.query.id)
            this.video_list = res.data.rows
          } else {
            this.$message.error(res.message)
          }
        }
        
      }
    },
    getCodeImg() {
      let dom = document.getElementById("qrcode")
      if(!this.qrcode){
        this.qrcode = new QRCode(document.getElementById("qrcode"), {
            text: this.video_detail.detail_url,
            width: 128,
            height: 128,
            colorDark : "#000000",
            colorLight : "#ffffff"
        });
      } else {
        this.qrcode.clear(); // 清除代码
        this.qrcode.makeCode(this.video_detail.detail_url); // 生成另外一个二维码
      }
      

    },
    module_isHover(val) {
      this.isHover = val
    },
    changeStyle(tabName) {
      this.templet.changeStyle(this.module, tabName)
    },
    edit() {
      this.showEditArticle = true
    },
    closeEditArticle() {
      this.showEditArticle = false
    },
    delete_video(id){
      deleteArtical({
        ids: id,
        type: 11
      }).then((e)=>{
        this.videoList();
      })
    }
  },
  watch: {
    'listArr.recommend'(val){
      if(this.listArr.recommend == 'block') this.videoList()
    },
    'listArr.articleList'(val){
      if(this.listArr.recommend == 'block') this.videoList()
    },
    '$store.state.app.view_pattern'(){
      if(this.listArr.recommend == 'block') this.videoList()
    },
    'pc_widgets_infor.recommendationOption'() {      
      this.videoList()
    },
    'recommend_video_num'() {
      this.videoList()
    }
  },
  components: {
    one_img,
    my_share_render
  }
};
</script>

<style scoped lang="scss">
.video-detail-container{
  overflow: hidden;
  .detail_share_tile {
    margin: 10px 0px;
  }
  .pc-detail-content{
    .video-top{
      padding: 10px;
      display: flex;
      overflow: hidden;
      width:100%;
      box-sizing: border-box;
      .video-center{
        // flex:1;
        // height:600px;
        width:43.75%;
        .video-border{
          position: relative;
          box-sizing: border-box;
          width: 100%;
          padding-bottom: 100%;
          border: 1px solid #eee;
          
          .video{
            /* object-fit: contain;
            width:100%;
            height:100%; */
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
          }

        }
        
      }
      .video-detail{
        // flex: 0 0 450px;
        // width:450px;
        width: 56.25%;
        margin-left: 40px;
        // font-size:20px;
        .video-title{
          margin-bottom: 20px;
          word-wrap:break-word;
          overflow: hidden;
          font-size: 20px;
          line-height: 40px;
          color: #333;
          word-break: break-word;
        }
        .video-desc{
          word-wrap:break-word;
        }
        .detail_func_wrap{
          display: flex;
          justify-content: space-between;
          line-height:35px;
          .share-left{
            display: flex;
            .detail_share{
              
            }
            .see-txt{
                font-size:14px;
                margin-left:20px;
                display: block;
                align-items: center;
                .icon-phone{
                  font-size:18px;
                  vertical-align:middle;
                }
                
              }
            .icon-download{
              font-size:18px;
              margin-left: 10px;
            }
          }
          
          .detail-play{
            font-size:16px;
            margin-right:20px;
          }
        }
        
        .detail_pagination_wrap {
          display: flex;
          width: 100%;
          flex-direction: row;
          justify-content: space-between;
          padding-top: 18px;

          .nav-btn-wrapper {
            cursor: pointer;
            display: flex;
            width: 50%;
            align-items: center;
          }

          .nav-btn-wrapper-left {
            padding-right: 20px;
          }

          .btn {
            box-sizing: border-box;
            display: inline-flex;
            width: 80px;
            height: 30px;
            line-height: 28px;
            text-align: center;
            border-radius: 15px;
            border: 1px solid #e9e9e9;
            cursor: pointer;
            justify-content: center;
            font-size: 14px;
            color: #333;
          }

          .nav-btn-title {
            flex: 1;
            padding-left: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            font-size: 14px;
            color: #333;
          }
        }


      }
    }
    .video-top-mb{
      padding: 0 3.6%;
      overflow: hidden;
      width:100%;
      box-sizing: border-box;
      .video-center{
        width:100%;
        .video{
          object-fit: cover;
          width:100%;
          height:100%;
        }
      }
      .video-title{
        //margin-bottom: 10px;
      }
      .detail_func_wrap{
        display: flex;
        justify-content: space-between;
        line-height:35px;
        .share-left{
          display: flex;
          .detail_share{
            margin-right:2px;
            .see-txt{
              font-size:14px;
              margin-left:10px;
            }
          }
          .icon-download{
            font-size:16px;
            margin-left: 10px;
          }
        }
        .download-wrap{
          display: flex;
          align-items: center;
        }
        .detail-play{
          // font-size:16px;
          // margin-right:20px;
        }
      }
      .video{
        //height:200px;
      }
    }
    .video-recommend{
      // padding: 0 10px;
       
      .recommend-title{
        margin: 20px 10px;
        font-size:18px;
        font-weight: bold;
        color:var(--theme_color)
      }
      .recommend-content{
        display: flex;
        // margin-left:-20px;
        flex-wrap: wrap;
       
        .recomment-list{
          transition: all 0.5s ease-out;
          width:calc(20% - 20px);
          flex: 0 0 calc(20% - 20px);
          box-sizing: border-box;
          margin:10px;
          color: #333;
          background: #fff;
          .list_one_wrap{
            position: relative;
            z-index: 1;
            padding: 5%;
            display: block;
            height: 100%;
            overflow: hidden;
            color: #333;
            &:hover{
              box-shadow: rgba(0, 0, 0, 0.1) 0 0 15px;
            }
          .video{
            padding-bottom: 100%;
            // box-sizing: border-box;
            height:0;
            width:100%;
            overflow: hidden;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat
            /* .img{
              position: absolute;
              width:100%;
              height:100%;
              object-fit: cover;  
            } */
          }
          .video-title{
            margin-bottom: 5px;
            margin-top: 15px;
            line-height:24px;
            text-align: center;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            font-size:16px;
          }
          }
          
        }
        
        
      }
      .empty{
        width:100%;
        .jz_empty_tips {
          width: 100%;
          padding: 90px 0;
          text-align: center;
        }
        .jz_empty_tips__img {
          display: block;
          width: 157px;
          height: 123px;
          margin: 0 auto;
        }
        .jz_empty_tips__text {
          margin-top: 28px;
          font-size: 16px;
          line-height: 24px;
          color: #333;
        }
      }
      
    }
    .video-recommend-mb{
      padding: 0 1.8%;
      .recommend-title{
        margin: 20px 0px;
        font-size:16px;
        font-weight: bold;
        padding: 0 1.8%;
      }
      .recommend-content{
        display: flex;
        flex-wrap: wrap;
        .recomment-list-mb{
          width:46.4%;
          box-sizing: border-box;
          margin: 0px 1.8% 20px;
           .list_one_wrap{
            position: relative;
            z-index: 1;
            padding: 0;
            display: block;
            height: 100%;
            overflow: hidden;
            color: #333;
            .video{
            // height:140px;
              padding-bottom: 100%;
              // box-sizing: border-box;
              height:0;
              width:100%;
              overflow: hidden;
              background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
            }
            .video-title{
              margin-top:10px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              text-align:center
            }
        }
          
        }
      }
    }
  }
}
/* .mb_pattern .video-top{
	display:none;
}
.pc_pattern .video-top-mb{
	display:none;
} */
@media screen and (max-width: 970px) {
  .basic_video_detail_index.video-detail-container{
   
    .pc-detail-content {
      .recommend-content.recommend-content-pc{
        display: none;
      }
      .video-top{
        display:none;
      }
    }
  }
  .basic_video_detail_index.video-detail-container{
    .pc-detail-content{
      /* .recommend-content.recommend-content-mb{
        display: flex;
      } */
      .video-top-mb{
        display:block;
      }
    }
    
  }
}
@media screen and (min-width: 970px) {
  .basic_video_detail_index.video-detail-container{
    
    .pc-detail-content {
      /* .recommend-content.recommend-content-pc{
        display: block;
      } */
      .video-top{
        display:flex;
      }
    }
  }
  .basic_video_detail_index.video-detail-container{
    .pc-detail-content{
     /*  .recommend-content.recommend-content-mb{
        display: none;
      } */
      .video-top-mb{
        display:none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_video_detail/index.vue